<template>
  <b-container v-if="isLoggedIn" class="live-bid">
    <b-row class="no-gutters">
      <b-col class="text-center">
        <div class="live-bid-inner">
          <radial-progress-bar
            v-if="active"
            :diameter="diameter"
            :completed-steps="completedSteps"
            :total-steps="totalSteps"
            :strokeWidth="strokeWidth"
            :startColor="startColor"
            :innerStrokeColor="innerStrokeColor"
            :strokeLinecap="strokeLinecap"
            :stopColor="stopColor"
            :backgroundColor="backgroundColor"
            :animateSpeed="animateSpeed"
            :class="classBid"
          >
            <div class="bid-time">{{ remainingSeconds }}</div>
            <div class="bid-amount" v-if="value > 0">
              {{ value | currency }}
            </div>
            <div class="bid-amount" v-if="value === 0">Sin oferta</div>
          </radial-progress-bar>

          <div
            class="mine"
            v-if="active && isLoggedIn && affiliateCode === loggedInMembership"
          >
            <font-awesome-icon icon="trophy" />
            <br />
            <span>¡ Mi oferta !</span>
          </div>

          <div
            class="other"
            v-else-if="isLoggedIn && active && affiliateCode > 0"
          >
            Oferta de otro afiliado
          </div>

          <span class="place-bid" v-if="active && !ended && isEnabled"
            >Puja:</span
          >

          <div class="bids" v-if="active && isEnabled">
            <div :class="classBid">
              <b-button
                variant="success"
                class="btn-placebid"
                v-on:click="placeBid(nextBid1000)"
                :style="placeBidStyle"
                >{{ nextBid1000 | currency }}</b-button
              >
            </div>

            <div :class="classBid">
              <b-button
                variant="success"
                class="btn-placebid"
                v-on:click="placeBid(nextBid500)"
                :style="placeBidStyle"
                >{{ nextBid500 | currency }}</b-button
              >
            </div>

            <div :class="classBid" v-if="value < 10000">
              <b-button
                variant="success"
                class="btn-placebid"
                v-on:click="placeBid(nextBid100)"
                :style="placeBidStyle"
                >{{ nextBid100 | currency }}</b-button
              >
            </div>

            <div
              :class="classBid"
              v-if="value > 10000 && currentValueMultiple500 > 0"
            >
              <b-button
                variant="success"
                class="btn-placebid"
                v-on:click="placeBid(nextBidMultiple500)"
                :style="placeBidStyle"
                >{{ nextBidMultiple500 | currency }}</b-button
              >
            </div>

            <div :class="classBid">
              <b-button
                variant="success"
                class="btn-placebid"
                v-on:click="placeManualBid"
                :style="placeBidStyle"
                >Otro monto</b-button
              >
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import RadialProgressBar from "../utils/RadialProgressBar";
import utils from "../../assets/js/utils";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
library.add(faTrophy);

export default {
  name: "LiveBid",
  components: {
    RadialProgressBar,
  },
  data() {
    return {
      completedSteps: 0,
      totalSteps: 10,
      startColor: "#51b100",
      innerStrokeColor: "#cfe8ba",
      strokeLinecap: "#000000",
      stopColor: "#51b100",
      diameter: 178,
      strokeWidth: 20,
      backgroundColor: "#e9ecef",
      remainingSeconds: 20,
      timer: null,
      animateSpeed: 1000,
      placeBidStyle: "visibility: visible",
      classBid: "on",
      value: 0,
      affiliateCode: 0,
      ended: false,
      active: false,
      changeable: false,
    };
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    auction: {
      type: Number,
      default: 0,
    },
  },
  filters: {
    currency: function (value) {
      return utils.formatCurrency(value);
    },
  },
  created() {
    this.windowResize();
    window.addEventListener("resize", this.windowResize);
  },
  watch: {
    id: function (newId) {
      this.changeable = false;

      if (
        !newId ||
        !this.$socket ||
        this.$socket.readyState !== WebSocket.OPEN
      ) {
        return;
      }
      this.$socket.sendObj({
        action: "getLiveBid",
      });
    },
    // Watch for WebSocket messages from the store
    '$store.getters.socketMessage': {
      handler: function(message) {
        if (!message || !message.message || !message.message.action) {
          return;
        }

        const self = this;
        switch (message.message.action) {
          case "auctionStarts": {
            if (message.message.carId !== self.id) {
              if (!self.changeable) {
                self.active = false;
                self.$emit("change-bid-status", "reset");
                return;
              }

              self.$router.replace({
                name: "Item",
                params: {
                  auction: self.auction,
                  item: message.message.carCode,
                },
              });
              return;
            }

            const remaining = message.message.remainingTime % 1000;

            setTimeout(function () {
              self.auctionStarts(
                message.message.bid,
                message.message.time,
                parseInt(message.message.remainingTime / 1000) * 1000,
                message.message.affiliateCode
              );
            }, remaining);

            break;
          }

          case "auctionBump":
            if (message.message.carId !== self.id) {
              return;
            }

            self.auctionStarts(
              message.message.bid,
              message.message.time,
              message.message.remainingTime,
              message.message.affiliateCode
            );
            break;

          case "auctionEnds":
            if (message.message.carId !== self.id) {
              return;
            }

            self.auctionEnds(
              message.message.affiliateCode,
              message.message.bid,
              message.message.notSold,
              message.message.pendingApproval
            );
        }
      },
      deep: true
    }
  },
  destroyed: function () {
    window.removeEventListener("resize", this.windowResize);
  },
  methods: {
    windowResize: function () {
      if (window.innerWidth < 768) {
        this.diameter = 122;
        this.strokeWidth = 15;
        this.backgroundColor = "#e9ecef";
      } else if (window.innerWidth < 992) {
        this.diameter = 108;
        this.strokeWidth = 10;
        this.backgroundColor = "transparent";
      } else if (window.innerWidth < 1200) {
        this.diameter = 148;
        this.strokeWidth = 15;
        this.backgroundColor = "transparent";
      } else {
        this.diameter = 178;
        this.strokeWidth = 20;
        this.backgroundColor = "transparent";
      }
    },

    tick: function () {
      if (this.completedSteps >= this.totalSteps || this.ended) {
        return;
      }

      this.completedSteps++;
      this.remainingSeconds = Number.isInteger(this.remainingSeconds)
        ? this.remainingSeconds - 1
        : this.remainingSeconds;

      if (
        !Number.isInteger(this.remainingSeconds) ||
        this.remainingSeconds <= this.totalSteps / 4
      ) {
        this.startColor = this.stopColor = "#a60000";
        this.innerStrokeColor = "#ee432d";
        this.classBid = "off";
      } else if (this.remainingSeconds <= this.totalSteps / 2) {
        this.startColor = this.stopColor = "#eed82d";
        this.innerStrokeColor = "#fffdc9";
        this.classBid = "almost";
      }

      this.timer = setTimeout(this.tick, 1000);
    },

    placeBid: function (amount) {
      this.$socket.sendObj({
        action: "bumpBid",
        id: this.id,
        code: this.loggedInMembership,
        bid: amount,
      });
    },

    auctionStarts: function (bid, time, remainingTime, affiliateCode) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(this.tick, 1000);
      this.value = bid;
      this.totalSteps = time / 1000 - 1;
      this.remainingSeconds = remainingTime / 1000;
      this.completedSteps = (time - remainingTime) / 1000;
      this.startColor = this.stopColor = "#51b100";
      this.innerStrokeColor = "#cfe8ba";
      this.animateSpeed = 1000;
      this.classBid = "on";
      this.affiliateCode = affiliateCode;
      this.active = true;
      this.placeBidStyle = "visibility: visible";
      this.ended = false;
      this.changeable = false;
      this.$emit("change-bid-status", "almost");
    },

    auctionEnds: function (affiliateCode, bid, notSold, pendingApproval) {
      this.ended = true;
      this.value = bid;
      this.affiliateCode = affiliateCode;
      this.startColor = this.stopColor = "#a60000";
      this.innerStrokeColor = "#ee432d";
      this.classBid = "off";
      this.completedSteps = this.totalSteps;
      this.remainingSeconds = notSold
        ? " No adjudicado "
        : pendingApproval
        ? " Sujeto a aprobación "
        : " ¡ Vendido !";
      this.placeBidStyle = "visibility: hidden";
      this.changeable = true;
      this.$emit("change-bid-status", "off");
    },

    placeManualBid: async function () {
      const roundText =
        this.value < 10000
          ? "a la centena superior"
          : "al múltiplo de 500 superior";

      const val = await this.$swal({
        title: "Coloca tu oferta",
        input: "text",
        html:
          "Valor en quetzales, <strong>será redondeado " +
          roundText +
          "</strong>.  <br />No hace falta ingresar símbolo de moneda.<br /><br /><strong>La oferta representa un compromiso de compra.</strong>",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        inputValidator: (value) => {
          if (!value) {
            return "Debes colocar el valor a ofertar";
          }
          if (!utils.checkAmount(value)) {
            return "Debes colocar una cantidad válida, en quetzales.  No coloques símbolo de moneda.";
          }
        },
      });

      if (!val.value) return;

      const multiple = this.value < 10000 ? 100 : 500;

      let value = Math.ceil(val.value / multiple) * multiple;
      if (value <= this.value) {
        value = this.value + multiple;
      }

      const valueString = Intl.NumberFormat("es-GT").format(value);

      const confirm = await this.$swal({
        title: "Por favor confirma tu oferta por: Q " + valueString,
        html: "El valor introducido pudo haber sido redondeado a la centena superior.<br /><br /><strong>La oferta representa un compromiso de compra.</strong>",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
      });

      if (!confirm.value) return;

      this.$socket.sendObj({
        action: "bumpBid",
        id: this.id,
        code: this.loggedInMembership,
        bid: value,
      });
    },
  },
  computed: {
    loggedInMembership: function () {
      return this.$store.getters.loggedInMembership;
    },
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    nextBid100: function () {
      return this.value + 100;
    },
    nextBid500: function () {
      return this.value + 500 + this.adjustBidMultiple500;
    },
    nextBid1000: function () {
      return this.value + 1000 + this.adjustBidMultiple500;
    },
    currentValueMultiple500: function () {
      return this.value % 500;
    },
    nextBidMultiple500: function () {
      return this.value + 500 - this.currentValueMultiple500;
    },
    adjustBidMultiple500: function () {
      return this.currentValueMultiple500 > 0 && this.value >= 10000
        ? 500 - this.currentValueMultiple500
        : 0;
    },
    isEnabled: function () {
      return this.$store.getters.isEnabled;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.bid-amount,
.bid-time {
  color: $green;
  font-weight: $font-weight-bold;
  line-height: 1.5rem;
  white-space: normal;
  width: 80%;
}

.on {
  .btn-placebid {
    background-color: $green;
    border-color: $green;

    &:hover,
    &:focus {
      background-color: darken($green, 15%);
    }
  }
}

.almost {
  .bid-amount,
  .bid-time {
    color: darken($yellow, 15%);
  }

  .btn-placebid {
    background-color: darken($yellow, 15%);
    border-color: darken($yellow, 15%);

    &:hover,
    &:focus {
      background-color: darken($yellow, 25%);
    }
  }
}

.off {
  .bid-amount,
  .bid-time {
    color: $redAlt;
  }

  .btn-placebid {
    background-color: $redAlt;
    border-color: $redAlt;

    &:hover,
    &:focus {
      background-color: darken($redAlt, 15%);
    }
  }
}

.btn-placebid {
  padding: 0.1rem 0.5rem;
}

.mine {
  color: $red;
  font-size: 1.5rem;
}

.other {
  font-size: 1.5rem;
}

.place-bid {
  font-weight: 600;
}

.live-bid-inner {
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  > * {
    flex: 1 0 auto;
  }
}

.bids {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > * {
    flex: 1 0 auto;
    margin: 5px 0;
  }
}

@media (max-width: prev-viewport-max-size("xl")) {
  .bid-amount,
  .bid-time,
  .btn-placebid {
    font-size: 0.9rem;
    line-height: 1.5rem;
  }
}

@media (max-width: prev-viewport-max-size("lg")) {
  .badge {
    font-size: 70%;
    padding: 0.4em 0.2em;
  }

  .bid-amount,
  .bid-time,
  .btn-placebid {
    font-size: 0.7rem;
    line-height: 1rem;
  }
}

@media (max-width: prev-viewport-max-size("md")) {
  .live-bid-inner {
    position: fixed;
    bottom: 20px;
    left: 10%;
    background-color: transparentize($color: #e9ecef, $amount: 0.2);
    border-radius: 0.5rem;
    padding: 0.5rem;
  }
}

@media (max-width: prev-viewport-max-size("sm")) {
  .live-bid-inner {
    left: initial;
    right: 10px;
  }
}
</style>
